import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  progress: PropTypes.number, // 0-100
  className: PropTypes.string,
};

export default function AtomProgressBar({ progress = 0, className }) {
  let progressWidth;

  if (progress === null) {
    return null;
  } else if (progress > 100) {
    progressWidth = "100%";
  } else if (progress <= 0) {
    progressWidth = 0;
  } else {
    progressWidth = `${progress}%`;
  }

  return (
    <div data-test-id="progress-bar" className={`w-full relative bg-offWhite rounded-lg text-wine ${className}`}>
      <div
        data-test-id="progress-bar-inner"
        className="h-full bg-current rounded-lg absolute"
        style={{ width: progressWidth }}></div>
    </div>
  );
}

AtomProgressBar.propTypes = propTypes;
